export default __webpack_public_path__ + "static/media/Clan Bound Boots of the Plains.a6fc9e00.jpg";